<template>
<div class="bottom-right d-flex flex-row align-items-end">
  <div @click="show = true" class="announce mr-1 bg-pink-300 " v-if="role === 'admin'">
    <i class="fas fa-bullhorn font-size-xs "></i>
  </div>
  <div class="online bg-slate-600" @click="setCollapse">
    <div v-if="!collapse">
      <div class="text-white" v-for="user in onlineUsers" :key="user.username">
        <i class="far fa-dot-circle text-small mr-2 text-green"></i>
        <span>{{user.username}}</span>
      </div>
    </div>
    <div class="text-white">Online Users ({{onlineUsers.length}})</div>
  </div>
  <b-modal v-if="role === 'admin'" v-model="show" centered id="announce" size="sm" title="Announcement"  no-close-on-backdrop>
    <div class="form">
      <textarea v-model="text" class="form-control" placeholder="Message"></textarea>
    </div>
    <template v-slot:modal-footer>
          <div>
              <button type="button" class="btn btn-link" @click="show = false">Cancel</button>
              <button type="button" class="btn bg-primary" @click="announce">Announce</button>
          </div>
    </template>
  </b-modal>
</div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    BModal
  },
  data () {
    return {
      collapse: true,
      text: '',
      show: false
    }
  },
  computed: {
    ...mapGetters({ users: 'onlineUsers', username: 'username', role: 'role' }),
    onlineUsers () {
      return this.users.filter(v => v.username !== this.username)
    }
  },
  methods: {
    setCollapse () {
      this.collapse = !this.collapse
    },
    announce () {
      if (this.text) {
        this.$socket.emit('broadcast', this.text)
        this.show = false
        this.text = ''
      }
    }
  }
}
</script>

<style scoped>
.bottom-right {
  z-index: 1;
  position:fixed;
  right: 20px;
  bottom:0px
}
.online {
  padding: 5px 10px 5px 10px;
  border-radius: 5px 5px 0px 0px;
  cursor: pointer;
  transition-duration: 1s
}
.announce {
  padding: 5px 10px 5px 10px;
  border-radius: 5px 5px 0px 0px;
  cursor: pointer;
  transition-duration: 1s;
}
.text-small {
  font-size: 9px
}
</style>
